/**
 * 转场特效 - tv-noise(电视雪花)
 * 2018-10-8
 */

(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        // CommonJS
        module.exports = factory(this);
    } else {
        //  全局变量
        factory(root);
    }
}(this, function (root) {
    // 类构造函数
    function con(sprite, option) {
        this.type = option.code || 'Smear'; //默认是从左移
        this.direction = option.direction || 'w'; //默认是从左移 // e - right东， w - left西， s - down南， n - up北
    }

    var methods =  {
        init: function() {
            var _this = this;
            return this.supr(true).then(function() {
                // return _this._init();
                var p = _this.playerSprite;
                var h1, v1, h2, v2, w, h;
                switch(_this.direction) {
                    default:
                    case 'w': // 左擦入 0
                        w = p.sprite.width * 2;
                        h = p.sprite.height;
                        h1 = 'right';
                        v1 = 'bottom';
                        h2 = 'left';
                        v2 = 'bottom';
                        _this.smearTypeFill = 0;
                        break;
                    case 'e': // 右擦入 1
                        w = p.sprite.width * 2;
                        h = p.sprite.height;
                        h1 = 'left';
                        v1 = 'bottom';
                        h2 = 'right';
                        v2 = 'bottom';
                        _this.smearTypeFill = 1;
                        break;
                    case 'n': // 上擦入 2
                        w = p.sprite.width;
                        h = p.sprite.height * 2;
                        h1 = 'left';
                        v1 = 'bottom';
                        h2 = 'left';
                        v2 = 'top';
                        _this.smearTypeFill = 2;
                        break;
                    case 's': // 从下擦入 3
                        w = p.sprite.width;
                        h = p.sprite.height * 2;
                        h1 = 'left';
                        v1 = 'top';
                        h2 = 'left';
                        v2 = 'bottom';
                        _this.smearTypeFill = 3;
                        break;
                }
                _this._maskImage = `-webkit-gradient(linear, ${h1} ${v1}, ${h2} ${v2}, color-stop(0.00, rgba(0,0,0,1)),color-stop(0.45, rgba(0,0,0,1)),color-stop(0.50, rgba(0,0,0,0)),color-stop(0.55, rgba(0,0,0,0)),color-stop(1.00, rgba(0,0,0,0)))`;
                p.ele.css({
                    "-webkit-mask-position": '0 0',
                    "-webkit-mask-size": `${w}px ${h}px`,
                    "-webkit-mask-image": _this._maskImage
                });
                _this.isInit = true;
                return Promise.resolve();
            }).catch(function(err) {
                throw "Error: " + err;
            });
        },
        // 重置播放路径
        reset: function() {
            // todo...
        },
        // show方法
        linear: function (t, b, c, d) {
            return c * (t / d) + b;
        },

        enterAnimFn: function(frame, playerEle) {
            this.supr(frame, playerEle);

            var sprite = this.sprite;
            var frameOff = frame - this.animFrame.entrance.start;

            var left, top, maskImage, w, h;
            switch(this.direction) {
                case 'e':
                    w = sprite.width * 2;
                    h = sprite.height;
                    left = this.linear(frameOff, -sprite.width, sprite.width, 0.5 * this.frameRate);
                    top = 0;
                    break;
                case 'w':
                    w = sprite.width * 2;
                    h = sprite.height;
                    left = this.linear(frameOff, 0, -(sprite.width), 0.5 * this.frameRate);
                    top = 0;
                    break;
                case 'n':
                    w = sprite.width;
                    h = sprite.height * 2;
                    top = this.linear(frameOff, 0, -(sprite.height), 0.5 * this.frameRate);
                    left = 0;
                    break;
                case 's':
                    w = sprite.width;
                    h = sprite.height * 2;
                    top = this.linear(frameOff, -sprite.height, sprite.height, 0.5 * this.frameRate);
                    left = 0;
                    break;
            }
            var judgeFill = false;
            if(this.exitAnim.type.indexOf('Smear') !== -1){
                if(this.exitAnim.smearTypeFill && this.exitAnim.smearTypeFill != this.smearTypeFill){
                    judgeFill = true;
                }
            }
            if ('none' === playerEle.css('-webkit-mask-image') || judgeFill) {
                playerEle.css({
                    "-webkit-mask-position": `${left}px ${top}px`,
                    "-webkit-mask-image": this._maskImage,
                    "-webkit-mask-size": `${w}px ${h}px`,
                    "left": sprite.positionLeft + 'px',
                    "top": sprite.positionTop + 'px'
                });
            } else {
                playerEle.css({
                    "-webkit-mask-position": `${left}px ${top}px`,
                    "-webkit-mask-size": `${w}px ${h}px`,
                    "left": sprite.positionLeft + 'px',
                    "top": sprite.positionTop + 'px'
                });
            }
        },

        stayAnimFn: function(frame, playerEle) {
            this.supr(frame, playerEle);
            playerEle.css('-webkit-mask-image', 'none');
        }
    }

    var statics = {
        exitAnim: function(frame) {
            var effect    = this.effect.exitAnim,
                editor    = this.editor,
                player    = editor.player,
                exitStart = this.effect.ms2fps(effect.start),   // 结束动画开始帧
                exitEnd   = this.effect.ms2fps(effect.end),     // 结束动画结束帧;
                playerSprite = player.spritesDict[this.uuid];

            var Pwidth    = playerSprite.sprite.effect.animFrame.path ? playerSprite.sprite.effect.animFrame.path.target.width : this.width,
                Pheight   = playerSprite.sprite.effect.animFrame.path ? playerSprite.sprite.effect.animFrame.path.target.height : this.height;
            effect.direction = effect.direction || 'w';

            var frameOff  = frame - exitStart; // 当前第几帧


            var left, top, h1, v1, h2, v2, w, h;
            switch(effect.direction) { // e - right东， w - left西， s - down南， n - up北
                default:
                case 'e':   // 0
                    left = Pwidth * ( frameOff / ( 0.5 * this.effect.frameRate) ) + -(Pwidth);
                    top = 0;

                    w = Pwidth * 2;
                    h = Pheight;
                    h1 = 'right';
                    v1 = 'bottom';
                    h2 = 'left';
                    v2 = 'bottom';
                    effect.smearTypeFill = 0;
                    break;
                case 'w': // 1
                    left = -(Pwidth) * ( frameOff / ( 0.5 * this.effect.frameRate) );
                    top = 0;

                    w = Pwidth * 2;
                    h = Pheight;
                    h1 = 'left';
                    v1 = 'bottom';
                    h2 = 'right';
                    v2 = 'bottom';
                    effect.smearTypeFill = 1;
                    break;
                case 'n':   // 3
                    top = -(Pheight) * ( frameOff / ( 0.5 * this.effect.frameRate) );
                    left = 0;

                    w = Pwidth;
                    h = Pheight * 2;
                    h1 = 'left';
                    v1 = 'top';
                    h2 = 'left';
                    v2 = 'bottom';
                    effect.smearTypeFill = 3;
                    break;
                case 's':   // 2
                    top = (Pheight) * ( frameOff / ( 0.5 * this.effect.frameRate) ) + -(Pheight);
                    left = 0;

                    w = Pwidth;
                    h = Pheight * 2;
                    h1 = 'left';
                    v1 = 'bottom';
                    h2 = 'left';
                    v2 = 'top';
                    effect.smearTypeFill = 2;
                    break;
            }
            effect._maskImage = `-webkit-gradient(linear, ${h1} ${v1}, ${h2} ${v2}, color-stop(0.00, rgba(0,0,0,1)),color-stop(0.45, rgba(0,0,0,1)),color-stop(0.50, rgba(0,0,0,0)),color-stop(0.55, rgba(0,0,0,0)),color-stop(1.00, rgba(0,0,0,0)))`;

            var judgeFill = false,
                thisPositionLeft = this.positionLeft,
                thisPositionTop  = this.positionTop,
                pathTarget = this.effect.animFrame.path;

            if (pathTarget) {
                thisPositionLeft = pathTarget.target.left;
                thisPositionTop = pathTarget.target.top;
                playerSprite.ele.css({
                    transform: 'rotate(' + pathTarget.target.rotate + 'deg) '
                });
            }
            if(this.effect.code.indexOf('Smear') !== -1){
                if(this.effect.smearTypeFill && this.effect.smearTypeFill != effect.smearTypeFill){
                    judgeFill = true;
                }
            }
            if ('none' === playerSprite.ele.css('-webkit-mask-image') || judgeFill) {
                playerSprite.ele.css({
                    "-webkit-mask-position": `${left}px ${top}px`,
                    "-webkit-mask-image": effect._maskImage,
                    "-webkit-mask-size": `${w}px ${h}px`,
                    "left": thisPositionLeft + 'px',
                    "top": thisPositionTop + 'px',
                });
            } else {
                playerSprite.ele.css({
                    "-webkit-mask-position": `${left}px ${top}px`,
                    "-webkit-mask-size": `${w}px ${h}px`,
                    "left": thisPositionLeft + 'px',
                    "top": thisPositionTop + 'px',
                });
            }
        },

    }

    if (root.AnimEditor) {
        root.AnimEditor.extendEffect('Smear', con, methods, statics);
        return;
    }

    return function(AnimEditor) {
        AnimEditor.extendEffect('Smear', con, methods, statics);
    }
}));


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/sprite-effects/smear.js
// module id = mc1W
// module chunks = 16